import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Trabajos from './components/pages/Trabajos';

import './styles/Trabajos.css';
import './styles/index.css';
import './styles/main.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/trabajos" element={<Trabajos />} />
      </Routes>
    </Router>
  );
}

export default App;
